<div class="tab-content">
  <div class="table-view">

    <!-- Table starts -->
    <p-table
      #contactsTable
      [value]="employeeWithlogin"
      [rows]="pageSize"
      dataKey="Id"
      [(selection)]="selectedEmployees"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      exportFilename="CustomerContactsLogin"
      (onPage)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}: {{totalItems}}"
      [totalRecords]="totalItems"
      [lazy]="true"
      [loading]="isLoading"
    >
      <!-- Caption -->
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <div class="table-options">
            <div class="pull-right">
              <div class="action-btns-group">
                <kuba-export
                  [reportData]="contactsTable.filteredValue || contactsTable.value"
                  [additionalData]="additionalData"
                  [filters]="{
                    name: nameFilter,
                    businessId: businessFilter,
                    userName: usernameFilter,
                    mobile: mobileFilter,
                    roleId: roleFilter,
                    department: departmentFilter,
                    withUserOnly: true,
                    sortField: 'Name',
                    sortOrder: 'ASC'
                  }"
                  [exportAllData]="true"
                  [getAllDataFn]="getAllEmployeesWithLoginForExport"
                  (loading)="$event ? showExportLoader() : hideExportLoader()"
                ></kuba-export>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Name">{{ "EMPLOYEE_NAME" | translate }}</th>
          <th pSortableColumn="DepartmentName">{{ "DEPARTMENT" | translate }}</th>
          <th pSortableColumn="BusinessName">{{ "BUSINESS" | translate }}</th>
          <th>{{ "USERNAME" | translate }}</th>
          <th>{{ "MOBILE" | translate }}</th>
          <th>{{ "ADDITIONAL_ROLE" | translate }}</th>
        </tr>
        <tr>
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="nameFilter"
              (input)="onFilterChange()"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="departmentFilter"
              (input)="onFilterChange()"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <p-select
              [options]="businesses"
              [(ngModel)]="businessFilter"
              (onChange)="onFilterChange()"
              placeholder="{{ 'SELECT' | translate }}"
              [showClear]="true"
              [filter]="true"
              optionLabel="label"
              optionValue="value"
              styleClass="p-column-filter"
            >
              <ng-template let-status pTemplate="item">
                {{ status.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="usernameFilter"
              (input)="onFilterChange()"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="mobileFilter"
              (input)="onFilterChange()"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <p-select
              [options]="roles"
              [(ngModel)]="roleFilter"
              (onChange)="onRoleChanged($event, ad)"
              #ad
              styleClass="p-column-filter"
              placeholder="Select"
              [showClear]="true"
            >
              <ng-template let-status pTemplate="item">
                {{ status.label | translate }}
              </ng-template>
            </p-select>
          </th>
        </tr>
      </ng-template>
      <!-- Body Content -->
      <ng-template pTemplate="body" let-employee>
        <tr>
          <td>
            <span>
              <a
                href="javascript:void(0);"
                (click)="openEmployeeInNewWindow(employee)"
                >{{ employee.Name }}</a
              >
            </span>
          </td>

          <td>
            <span>{{ employee.DepartmentName }}</span>
          </td>
          <td>
            <span>
              <a
                href="javascript:void(0);"
                (click)="openBusinessInNewWindow(employee)"
                >{{ employee.BusinessName }}</a
              >
            </span>
          </td>
          <td>
            <span>
              <a
                [routerLink]="[
                  '../../../business/edit/' +
                    employee.BusinessId +
                    '/user/edit/',
                  employee.UserId
                ]"
                [queryParams]="{ Title: 'Employee' }"
                >{{ employee.UserName }}</a
              >
            </span>
          </td>
          <td>
            <span>{{ employee.Mobile }}</span>
          </td>
          <td>
            <span>{{ employee.RoleName }}</span>
          </td>
        </tr>
      </ng-template>
      <!-- Empty message -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td colspan="6">
            {{ "NO_RECORDS_FOUND" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- Table ends -->
  </div>
  <export-progress-dialog [visible]="exportInProgress"></export-progress-dialog>
<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  icon="pi pi-question-circle"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
